import { emailRegex } from '@/helpers/common';

export default {
  params: [
    {
      name: 'required',
      default: true,
    },
  ],
  validate: (value, params) => {
    let valid = true;

    if (params.required && !emailRegex.test(value)) {
      valid = false;
    }

    return {
      valid,
      required: params.required,
    };
  },
  message: 'Please enter a valid email address.',
  computesRequired: true,
};
